// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#auth-container[data-v-3ef356b2]{margin-top:50px}.tab-content[data-v-3ef356b2]{padding-top:20px}", ""]);
// Exports
module.exports = exports;
